// components/EventCard.jsx

import dayjs from "dayjs";

export default function EventCard({ event }) {

  const fecha = event.start_date_hour?.toDate
    ? dayjs(event.start_date_hour.toDate())
    : dayjs(event.start_date_hour);

  return (

    <div className="event-card">

      <h2 className="event-title">
        {event.event_code}
      </h2>

      <div className="event-meta">

        <span>
          {event.zone}
        </span>

        <span>
          {fecha.format("DD/MM/YYYY - HH:mm")} hs
        </span>

        <span
          className={
            event.status
              ? "status-ok"
              : "status-pending"
          }
        >
          {event.status
            ? "Finalizado"
            : "Pendiente"}
        </span>

      </div>

      <div className="event-description">
        {event.decription}
      </div>

    </div>
  );
}